<p>revelation-today-uid works!</p>
